<template>
    <section class="panel panel-default" style="position: relative;">
        <div class="panel-heading clearfix">
            <h4>Media Library</h4>
        </div>
        <div class="panel-body">
            <div class="item" style="grid-column: 1/3">
                <file-uploader :theme="theme" @uploaded="fetchMedia()" style="height: 100%"/>
            </div>

            <div v-for="file in media" class="item">
                <div class="preview" @click="pasteIntoEditor(file)">
                    <img :src="`/media/${file.id}`" alt="" v-if="file.mime_type.startsWith('image/')" title="click to insert">
                    <span class="icon" v-else>
                        <span :class="`fa-3x ${icon(file.mime_type)}`"></span>
                    </span>
                </div>

                {{ file.name }}
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";
import FileUploader from "./FileUploader";
import {getIconClassFromMimeType} from '../Support/FontAwesomeMimeMapper'

export default {
    props: [
        'theme'
    ],

    data() {
        return {
            media: [],
            copyIndicator: false,
        }
    },

    methods: {
        async fetchMedia() {
            let res    = await axios.get(`/media?theme=${this.theme}`)
            let {data} = await res

            this.media = data
        },

        icon(mimeType) {
            return getIconClassFromMimeType(mimeType)
        },

        pasteIntoEditor(file) {
            this.$root.$emit('paste-img', {
                name    : file.name,
                mediaUrl: `${origin}/media/${file.id}`,
                isImage : file.mime_type.startsWith('image/')
            })
        }
    },

    mounted() {
        this.fetchMedia()
    },

    components: {
        FileUploader,
    }
}
</script>

<style lang="scss" scoped>
    .panel-body {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-gap: 25px;

        &:before, &:after {
            display: none !important;
            content: "" !important;
        }

        .item {
            height: 15rem;
            overflow: hidden;
            text-overflow: ellipsis;

            .preview {
                height: calc(100% - 20px);
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                    object-position: center;
                }
            }
        }
    }
</style>